import styled from "styled-components/macro";
import { Telephone } from "../../assets/iconComponents/Telephone";
import { Email } from "../../assets/iconComponents/Email";
import { Fax } from "../../assets/iconComponents/Fax";
import { DeviceType } from "../../utils/hooks/useDeviceHook";

const getFooterPadding = (deviceType?: DeviceType) => {
  if (deviceType === "mobile") {
    return "40px 20px 25px 24px";
  }
  if (deviceType === "tablet") {
    return "50px 45px 25px 45px";
  }
  return "20px";
};

export const FooterStyled = styled.div<{
  deviceType: DeviceType;
}>`
  background-color: ${({ theme }) => theme.neutral100};
  text-align: left;
  height: auto;
  padding: ${({ deviceType }) => getFooterPadding(deviceType)};
`;

export const FooterUnityContainer = styled.div<{
  isDesktop: boolean;
}>`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 10px;
  padding-bottom: ${({ isDesktop }) => (isDesktop ? "20px" : "0px")};
`;

export const FooterUnityImage = styled.img``;

export const FooterContactContainer = styled.div<{
  deviceType: DeviceType;
}>`
  display: inline-grid;
  grid-template-columns: auto auto;
  grid-gap: 10px;
  padding: ${({ deviceType }) =>
    deviceType === "desktop" ? "15px 0 10px 0" : "30px 0 10px 0"};
`;

export const FooterDesktopContactContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 10px;
  padding-top: 20px;
`;

export const FooterSocialContainer = styled.div`
  display: inline-grid;
  grid-template-columns: auto auto auto;
  grid-gap: 33px;
  padding-top: 15px;
  &:hover {
    svg {
      cursor: pointer;
    }
  }
`;

export const FooterLinksContainer = styled.div<{
  deviceType: DeviceType;
}>`
  display: grid;
  grid-template-columns: ${({ deviceType }) =>
    deviceType === "desktop" ? "1fr 1fr 1fr" : "1fr 1fr"};
  padding: ${({ deviceType }) =>
    deviceType === "desktop" ? "0 0 100px 0" : "7px 0 10px 0"};
  grid-gap: 10px 0;
`;

export const FooterLegalContainer = styled.div<{
  isDesktop: boolean;
}>`
  width: ${({ isDesktop }) => (isDesktop ? "fit-content" : "100%")};
  display: flex;
  justify-content: space-between;
  padding-bottom: ${({ isDesktop }) => (isDesktop ? "0px" : "10px")};
`;
export const FooterPrivacyContainerNew = styled.div`
  display: flex;
  white-space: break-spaces;
  width: fit-content;
  flex-wrap: wrap;
  > * {
    flex: 1 1 100%;
  }
`;

export const FooterAccreditationRow = styled.div`
  display: flex;
  white-space: break-spaces;
  flex-wrap: wrap;
  align-items: center;
  gap: 0 4px;
`;

export const FooterPrivacyContainerTelephone = styled.div`
  display: grid;
`;

export const FooterPrivacyContainerTelephoneRow = styled.div`
  display: flex;
  white-space: break-spaces;
  width: fit-content;
  flex-wrap: wrap;
`;

export const FooterPrivacyContainer = styled.div`
  display: inline-grid;
  grid-template-columns: auto auto auto;
  grid-gap: 3px;
`;

export const FooterAccreditationContainerDesktop = styled.div`
  display: inline-grid;
  grid-template-columns: auto auto auto auto auto auto auto auto auto auto auto;
  grid-gap: 3px;
`;

export const FooterAccredContainerNotDesktop1 = styled.div`
  display: inline-grid;
  grid-template-columns: auto auto auto auto;
  white-space: nowrap;
  grid-gap: 3px;
`;

export const FooterAccredContainerNotDesktop2 = styled.div`
  display: inline-grid;
  grid-template-columns: auto auto auto auto auto auto auto;
  white-space: nowrap;
  grid-gap: 3px;
`;

export const FooterHr = styled.hr`
  border: 1px solid ${({ theme }) => theme.neutral300};
  margin: 25px 0px 25px 0px;
`;

export const FooterPaddedTelephone = styled(Telephone)`
  margin-top: 1px;
`;

export const FooterPaddedEmail = styled(Email)`
  margin-top: 2px;
`;

export const FooterPaddedFax = styled(Fax)`
  margin-top: 1px;
`;
export const FooterWrapper = styled.div<{
  isDesktop: boolean;
}>`
  display: grid;
  grid-template-columns: ${({ isDesktop }) =>
    isDesktop ? "auto auto auto" : "1fr"};
  grid-gap: 20px;
`;
export const PatentContent = styled.div<{
  isDesktop: boolean;
}>`
  white-space: ${({ isDesktop }) => (isDesktop ? "pre" : "pre-wrap")};
`;

export const FooterLegalContent = styled.div`
  width: 100%;
  display: block;
  white-space: pre-line;
`;

export const FooterLink = styled.span`
  p {
    text-decoration: underline;
  }
`;
